import styled from "styled-components";

export const theme = {
	blue: {
		default: "#3f51b5",
		hover: "#283593",
	},
	pink: {
		default: "#ad1457",
		hover: "#e91e63",
	},
	green: {
		default: "#14ad57",
		hover: "#1ee963",
	},
	grey: {
		default: "#6c757d",
		hover: "#4e5861",
	},
	blue2: {
		default: "#367a99",
		hover: "#31657d",
	},
	black: {
		default: "#000000",
		hover: "#000000",
	},
};

export const Button = styled.button`
  background-color: ${(props) => theme[props.theme].default};
  color: white;
  width: 100%;
  padding: 5px 15px;
  border-radius: 5px;
  outline: 0;
  margin: 3px 0px;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  },
`;
Button.defaultProps = {
	theme: "blue",
};

export const Button2 = styled.button`
background-color: ${(props) => theme[props.theme].default};
color: white;
padding: 5px 15px;
border-radius: 5px;
outline: 0;
margin: 3px 0px;
cursor: pointer;
box-shadow: 0px 2px 2px lightgray;
transition: ease background-color 250ms;
&:hover {
  background-color: ${(props) => theme[props.theme].hover};
}
&:disabled {
  cursor: default;
  opacity: 0.7;
},
`;

Button2.defaultProps = {
	theme: "grey",
};
